import React, {useEffect, useState} from "react";
import CloseIcon from "@material-ui/icons/Close";
import "./alertWeb.scss";

const AlertWeb = ({ id, testo, coloreBg, coloreTesto, alertSection, activeSection, isClosable }) => {
    const [open, setOpen] = useState(true);

    useEffect(() => {
        setOpen(true);
    }, [testo, alertSection, activeSection]);

    const handleClose = () => {
        setOpen(false);
        if (isClosable === 1 && id) {
            const closedAlerts = JSON.parse(localStorage.getItem("closedAlerts") || "[]");
            if (!closedAlerts.includes(id)) {
                closedAlerts.push(id);
                localStorage.setItem("closedAlerts", JSON.stringify(closedAlerts));
            }
        }
    };

    if (!testo || !open || !(alertSection.toLowerCase() === "all" || alertSection.toLowerCase() === activeSection.toLowerCase())) return null;

    return (
        <div className="alert-web" style={{ background: coloreBg, color: coloreTesto }} role="alert">
            <span>{testo}</span>
            {isClosable === 1 && (
                <button className="alert-web__close" onClick={handleClose} aria-label="Chiudi alert">
                    <CloseIcon fontSize="small" />
                </button>
            )}
        </div>
    );
};

export default AlertWeb;
